import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readSite, readSites } from "../services/siteApi";

export function useSiteQuery(public_id, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["site", public_id],
    queryFn: () => readSite(public_id),
    enabled: isOpen && !!public_id,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useSitesQuery() {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["sites"],
    queryFn: () => readSites(),
  });
}
